/*
 * @Author: chi.yong chi.yong@jitai.ai
 * @Date: 2024-05-10 14:39:15
 * @LastEditors: chi.yong chi.yong@jitai.ai
 * @LastEditTime: 2025-01-10 14:26:05
 * @FilePath: /JTFE_home_user/src/stores/userStore.ts
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */

export const useUserStore = defineStore(
  'user',
  () => {
    // init
    const userInfo = ref({});
    const isSuper = ref(false);
    watch(userInfo, (info) => {
      isSuper.value = info.product_code?.includes('jt_gd');
    });
    const setUser = (result) => {
      userInfo.value = {
        ...userInfo.value,
        ...result
      };
    };
    const resetUser = () => {
      userInfo.value = {};
    };

    const pricing = ref();
    const setPricing = (selected) => {
      pricing.value = selected;
    };

    const searchHist = ref([
      {
        name: '搜索历史',
        value: {
          type: 'hist'
        }
      }
    ]);

    const setSearchHist = (item) => {
      // 检查是否已存在，去重逻辑
      const isDuplicate = searchHist.value.some((histItem) => histItem.name === `${item.name} ${item.code}`);
      if (!isDuplicate) {
        // 限量存储20个
        if (searchHist.value.length >= 20) {
          searchHist.value.pop(); // 删除最后一个元素
        }
        // 在 index=1 插入新项
        searchHist.value.splice(1, 0, { name: `${item.name} ${item.code}`, value: { ...item, isHist: true } });
        console.log('Inserted:', item);
      } else {
        console.log('Duplicate item, not inserted:', item);
      }
      console.log('searchHist.value after:', searchHist.value);
    };

    const delSearchHist = (item) => {
      // 通过  code 删除对应的历史项
      const index = searchHist.value.findIndex((histItem) => histItem.value.code === item.value.code);
      if (index !== -1) {
        // 删除找到的项
        searchHist.value.splice(index, 1); // 通过 splice 删除指定索引位置的元素
        console.log('Deleted:', item);
      } else {
        console.log('Item not found for deletion:', item);
      }
      console.log('searchHist.value after deletion:', searchHist.value);
    };

    return { userInfo, setUser, resetUser, isSuper, pricing, setPricing, searchHist, setSearchHist, delSearchHist };
  },
  {
    persist: {
      enabled: true,
      strategies: [
        {
          key: 'userStore',
          storage: sessionStorage
        }
      ]
    }
  }
);
